import { makeStyles } from '@mui/styles';

const useAddGuidesRangeFormStyles = makeStyles({
	h3: {
		fontSize: 18,
		fontFamily: 'Montserrat',
		fontWeight: '500',
		color: '#003C82',
	},
	textField: {
		'& input': {
			fontFamily: 'Montserrat',
			fontWeight: '500',
			fontSize: 14,
			color: 'rgb(0 0 0 / 64%)',
		},
		'& textarea': {
			fontFamily: 'Montserrat',
			fontWeight: '500',
			fontSize: 14,
			color: 'rgb(0 0 0 / 64%)',
		},
	},
});

export default useAddGuidesRangeFormStyles;
